import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('transaction');
const GET_TRANSACTIONS = define('GET_TRANSACTIONS', true);
const GET_TRANSACTION = define('GET_TRANSACTION', true);
const RECHARGE_TRANSACTION = define('RECHARGE_TRANSACTION', true);

const initialState = {
  isLoadingTransactions: true,
  transactions: [],
  isLoadingTransaction: true,
  transaction: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRANSACTIONS.PENDING:
      return {
        ...state,
        isLoadingTransactions: true
      };
    case GET_TRANSACTIONS.RESOLVED:
      return {
        ...state,
        isLoadingTransactions: false,
        transactions: action.data
      };
    case GET_TRANSACTION.PENDING:
      return {
        ...state,
        isLoadingTransaction: true,
      };
    case GET_TRANSACTION.RESOLVED:
      return {
        ...state,
        isLoadingTransaction: false,
        transaction: action.data
      };
    default: return state;
  }
};

export const actions = {
  getTransactions: () => ({
    type: GET_TRANSACTIONS,
    promise: api.get('/partner/transactions'),
    error: 'Unable to load transactions. Please try again.'
  }),
  getTransaction: (id) => ({
    type: GET_TRANSACTION,
    promise: api.get(`/partner/transactions/${id}`),
    error: 'Unable to load transaction details. Please try again.'
  }),
  rechargeTransaction: (id) => ({
    type: RECHARGE_TRANSACTION,
    promise: api.post(`/partner/transactions/${id}/charge`),
  })
};



// WEBPACK FOOTER //
// ./src/modules/transaction.js